import { createContext, ReactNode, useContext } from 'react';

import React from 'react';

export type GctlConfig = {
  baseUrl?: string;
  jwt?: string;
  xVimeoPage?: string;
  locale?: string;
};

let Context = createContext<GctlConfig>({});

type Props = {
  children: ReactNode;
  jwt?: string;
  baseUrl?: string;
  xVimeoPage?: string;
  locale?: string;
};

export function GctlProvider({ children, jwt, baseUrl, xVimeoPage, locale }: Props) {
  return (
    <Context.Provider value={{ jwt, baseUrl, xVimeoPage, locale }}>{children}</Context.Provider>
  );
}

export function useGctlConfig() {
  return useContext(Context);
}
